import styled from "styled-components";
import { screenSize } from "../../theme";
import {
  ProductHeader,
  ProductHeaderActions,
} from "../../pages/SharedPages/ProductDetailPage/ProductDetailPage";
import {
  HeaderContainer,
  SubheaderContainer,
  SubheaderInformationContainer,
} from "../Layout/Layout";
import { PROFILE_DETAIL_CLASSES } from "../../layout/shared/ProfileDetailLayout";

// Common layout components used by both PortfolioModernView and ProductsList

export const ViewSwitcher = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  background: ${({ theme }) => theme.resolve("color_bg_surface_standard")};
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
  border: ${({ theme }) => theme.resolve("border_sm")} solid
    ${({ theme }) => theme.resolve("color_border_light")};
  overflow: hidden;
`;

export const ViewButton = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.resolve("spacing_md")};
  border: none;
  background: ${({ isActive, theme }) =>
    isActive ? theme.resolve("color_bg_surface_subtle") : "transparent"};
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: ${({ theme }) => theme.resolve("spacing_5xl")};
  min-height: ${({ theme }) => theme.resolve("spacing_5xl")};
  box-shadow: ${({ isActive, theme }) =>
    isActive ? `0 1px 3px ${theme.resolve("color_neutral_gray300")}` : "none"};

  svg {
    width: ${({ theme }) => theme.resolve("spacing_3xl")};
    height: ${({ theme }) => theme.resolve("spacing_3xl")};
  }

  &:hover {
    background: ${({ isActive, theme }) =>
      isActive
        ? theme.resolve("color_bg_surface_subtle")
        : theme.resolve("color_bg_surface_standard")};
  }
`;

export const ProductCountDisplay = styled.div`
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  color: ${({ theme }) => theme.resolve("color_neutral_gray600")};
  white-space: nowrap;
`;
export const ProductSidebarWrapper = styled.div`
  width: 380px;
  min-width: 380px;
  height: 100%;
  padding: ${({ theme }) => theme.resolve("spacing_xl")};
`;
export const ProductSidebarContent = styled.div`
  height: 100%;
  overflow: auto;
  min-height: -webkit-fill-available;
`;
export const ProductSidebar = styled.div`
  height: 100%;
  overflow: hidden;
  min-height: -webkit-fill-available;
  background: ${({ theme }) => theme.resolve("color_cardProduct_bg")};
  border-radius: ${({ theme }) => theme.resolve("radius_cardProduct")};
  box-shadow: ${({ theme }) => theme.resolve("effect_cardProduct_shadow_x")}
    ${({ theme }) => theme.resolve("effect_cardProduct_shadow_y")}
    ${({ theme }) => theme.resolve("effect_cardProduct_shadow_blur")}
    ${({ theme }) => theme.resolve("effect_cardProduct_shadow_spread")}
    ${({ theme }) => theme.resolve("effect_cardProduct_shadow_color")};
  transition: box-shadow 0.2s ease-in-out;
  border-top: ${({ theme }) =>
    `${theme.resolve("border_cardProduct_top")} solid ${theme.resolve(
      "color_cardProduct_border"
    )}`};
  border-right: ${({ theme }) =>
    `${theme.resolve("border_cardProduct_right")} solid ${theme.resolve(
      "color_cardProduct_border"
    )}`};
  border-bottom: ${({ theme }) =>
    `${theme.resolve("border_cardProduct_bottom")} solid ${theme.resolve(
      "color_cardProduct_border"
    )}`};
  border-left: ${({ theme }) =>
    `${theme.resolve("border_cardProduct_left")} solid ${theme.resolve(
      "color_cardProduct_border"
    )}`};
  transition: border-color 0.2s ease-in-out, border-width 0.2s ease-in-out;

  ${ProductHeader} {
    flex-direction: column;
    justify-content: flex-start;
    margin: 0;
  }
    ${HeaderContainer}{
    margin: ${({ theme }) => theme.resolve("spacing_lg")}  ${({ theme }) =>
  theme.resolve("spacing_xl")} 0;
    width: -webkit-fill-available;
  }
  ${SubheaderInformationContainer} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: ${({ theme }) => theme.resolve("spacing_xs")};
    margin: 0;
  }

  ${SubheaderContainer} {
    margin: 0;
  }

  div.${PROFILE_DETAIL_CLASSES.groupCard} {
    background-color: var(--color_neutral_white);
    padding: ${({ theme }) => theme.resolve("spacing_2xl")};
    margin: 0  ${({ theme }) => theme.resolve("spacing_xl")}  ${({ theme }) =>
  theme.resolve("spacing_xl")};
    border: ${({ theme }) => theme.resolve("border_md")} solid ${({ theme }) =>
  theme.resolve("color_border_light")};
    border-radius: ${({ theme }) => theme.resolve("radius_cardProduct")};
    width: fill-available;
    width: -webkit-fill-available;
    div {
      border: none;
    }
        div[class*="portalPageLayout__TwoColumGrid"] {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.resolve("spacing_md")};
    p {
      margin: 0;
    }
  }
  }

  ${ProductHeaderActions}, div[class*="ProductDetailsTransactionsButtons"] {
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: flex-start;
    margin: ${({ theme }) => theme.resolve("spacing_md")} 0 ${({ theme }) =>
  theme.resolve("spacing_xl")};
    gap: ${({ theme }) => theme.resolve("spacing_md")};
    width: 100%;
    align-items: stretch;
    button {
      width: 100%;
      margin-bottom: 0;
      padding: ${({ theme }) => theme.resolve("spacing_md")}
        ${({ theme }) => theme.resolve("spacing_xl")} !important;
      margin: 0;
      font-size: var(--font_size_base);
      border-width: ${({ theme }) => theme.resolve("border_md")};
      svg {
        vertical-align: sub;
        margin-right: var(--spacing_xs);
    }
  }

  div[class*="ProductDetailsTransactionsButtons"] {
    margin-bottom: 0 !important;
    flex-direction: column;
  }
`;

export const ContentContainer = styled.div<{ showFilters: boolean }>`
  padding: 0;
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
  flex: 1;
  height: 100%;
  overflow: auto;
`;

export const StickyHeaderContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  background: ${({ theme }) => theme.resolve("color_neutral_white")};
  padding: ${({ theme }) => theme.resolve("spacing_xl")};

  /* Create full-width border */
  border-bottom: ${({ theme }) => theme.resolve("border_sm")} solid
    ${({ theme }) => theme.resolve("color_border_light")};
`;

export const FilterButtonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SearchAndFiltersRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-width: ${({ theme }) => theme.resolve("width_md")};
  @media ${screenSize.medium} {
    min-width: ${({ theme }) => theme.resolve("width_xxxs")};
  }
  align-items: flex-start;
`;

export const SelectedFiltersWrapper = styled.div<{ hasFilters: boolean }>`
  display: flex;
  align-items: center;
  height: ${({ hasFilters }) => (hasFilters ? "auto" : "0")};
  overflow: ${({ hasFilters }) => (hasFilters ? "visible" : "hidden")};
`;

export const MainContentWrapper = styled.div<{ showFilters: boolean }>`
  padding: ${({ theme }) => theme.resolve("spacing_xl")};
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  .table-with-bulk-action {
    height: 100%;
    overflow: auto;
  }
`;

export const StickyFiltersContainer = styled.div<{ show: boolean }>`
  position: ${({ show }) => (show ? "sticky" : "relative")};
  top: ${({ show }) => (show ? "0" : "auto")};
  z-index: ${({ show }) => (show ? "1" : "auto")};
  height: ${({ show }) => (show ? "100%" : "auto")};
  overflow-y: ${({ show }) => (show ? "auto" : "visible")};
  overflow-x: ${({ show }) => (show ? "visible" : "hidden")};
  width: ${({ show }) => (show ? "auto" : "0")};
  flex-shrink: 0;
  border-right: ${({ show, theme }) =>
    show
      ? `${theme.resolve("border_filterPanel")} solid ${theme.resolve(
          "color_filterPanel_border"
        )}`
      : "none"};
  background: ${({ theme }) => theme.resolve("color_filterGroup_bg_collpased")};
  width: ${({ show }) => (show ? "330px" : "0")};
  @media ${screenSize.small} {
    width: ${({ show }) => (show ? "100%" : "0")};
    border-right: none;
    position: ${({ show }) => (show ? "fixed" : "relative")};
    top: 0;
    padding-top: 55px;
    background: #00000095;
    z-index: 10;
  }
`;

export const RightSideControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  flex-shrink: 0;
  margin-left: auto; /* Push to the right */
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
`;

export const FullwidthPageWrapper = styled.div`
  max-width: 100%;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* Remove right padding to eliminate extra spacing on product cards */
  padding-right: 0;
  /* Remove bottom padding to fix scrolling issue where filter border doesn't touch bottom */
  padding-bottom: 0;
`;

export const StickyFiltersAndTotalWrapper = styled.div`
  position: sticky;
  top: 0px;
  z-index: 3;
  background: ${({ theme }) => theme.resolve("color_neutral_white")};
  padding: 0 ${({ theme }) => theme.resolve("spacing_xl")}
    ${({ theme }) => theme.resolve("spacing_md")};
  margin: 0 -${({ theme }) => theme.resolve("spacing_xl")};

  /* Ensure no gap at the top */
  &::before {
    content: "";
    position: absolute;
    top: -16px;
    left: 0;
    right: 0;
    height: 16px;
    background: ${({ theme }) => theme.resolve("color_neutral_white")};
    z-index: -1;
  }
`;

export const ProductsContentWrapper = styled.div`
  margin-top: ${({ theme }) => theme.resolve("spacing_md")};
`;

export const ProductsGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.resolve("spacing_xl")};
  padding: ${({ theme }) => theme.resolve("spacing_lg")} 0;
  z-index: 1;
`;

export const Breadcrumb = styled.div<{
  pageLayout?: string;
  isXlScreen?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  color: ${({ theme }) => theme.resolve("color_text_secondary")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_semibold")};
  margin-bottom: ${({ theme }) => theme.resolve("spacing_md")};
  div[class*="LinkUnstyled"] a {
    text-decoration: underline !important;
    color: ${({ theme }) => theme.resolve("color_text_secondary")} !important;
  }
`;

export const TotalProducts = styled.div`
  color: ${({ theme }) => theme.resolve("color_neutral_gray500")};
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  margin: 0 0 ${({ theme }) => theme.resolve("spacing_md")};
  height: 15px;
`;

export const LoaderContainer = styled.div`
  border: none;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.resolve("spacing_xl")};
`;

export const PortfolioSearch = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
  .searchBar {
    max-width: 515px;
  }
`;
